// Format 24hr time string (HH:MM) to 12hr with AM/PM
export const formatTime12hr = (timeStr) => {
  if (!timeStr) return '';
  const [hours, minutes] = timeStr.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const displayHour = hours % 12 || 12;
  return `${displayHour}:${minutes.toString().padStart(2, '0')} ${period}`;
};

// Format date string (YYYY-MM-DD or ISO) for display without timezone shift
export const formatEventDate = (dateStr) => {
  if (!dateStr) return '';
  const d = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr;
  const [year, month, day] = d.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString();
};

// Parse event date string as end-of-day local time so events stay active all day
export const parseEventDate = (dateStr) => {
  if (!dateStr) return new Date(0);
  const d = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr;
  const [year, month, day] = d.split('-').map(Number);
  return new Date(year, month - 1, day, 23, 59, 59); // 11:59:59 PM local time
};

// Helper: relative time (Instagram-style)
export const getRelativeTime = (timestamp) => {
  const now = Date.now();
  const diff = now - new Date(timestamp).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'now';
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d`;
  const weeks = Math.floor(days / 7);
  if (weeks < 52) return `${weeks}w`;
  return `${Math.floor(weeks / 52)}y`;
};
